export default "__VITE_ASSET__45027e61__"